import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
import { Cookie } from '@as-react/common-types';
import { CookieUtil } from '@as-react/common-utils';
export var CheckoutVersion;
(function (CheckoutVersion) {
    CheckoutVersion[CheckoutVersion["OLD"] = 1] = "OLD";
    CheckoutVersion[CheckoutVersion["NEW"] = 2] = "NEW";
})(CheckoutVersion || (CheckoutVersion = {}));
const checkoutEndpoints = {
    initiate: 'api/checkout/initiate',
    dtmCheckoutStep: 'api/dtm/checkoutstep',
};
class CheckoutAPI {
    constructor() {
        this.initRequest = (servicesApi, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${checkoutEndpoints.initiate}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { checkoutVersion: CheckoutVersion.NEW }),
                withCredentials: true,
                data: {
                    adobeUuid: CookieUtil.get(Cookie._UUID),
                    visitorId: CookieUtil.getByRegexp(/^AMCV_.+AdobeOrg/i),
                    userAgent: navigator.userAgent,
                    fredhopperSegment: CookieUtil.get(Cookie.FREDHOPPER_SEGMENT),
                    consentSetting: CookieUtil.get(Cookie.CONSENT_SETTING),
                },
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.checkoutStepDtm = (servicesApi, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                params: defaultRequestParams,
                url: `${servicesApi}${checkoutEndpoints.dtmCheckoutStep}`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new CheckoutAPI();
